const TokenList = () => import('./index')
const TokenNew = () => import('./new')

export default [
  {
    path: '/tokens',
    name: 'token.index',
    component: TokenList,
    meta: { requiresAuth: true }
  },
  {
    path: '/tokens/new',
    name: 'token.new',
    component: TokenNew,
    meta: { requiresAuth: true }
  }
]



// WEBPACK FOOTER //
// ./src/features/tokens/routes.js